import React from "react";
import Select from 'react-select';

const CandidateFirstForm = ({ setInputs, setStep, inputs }) => {

    console.log(inputs);

    const select = document.getElementById("name");

    const handleChange = (e) => {
        const {name, value} = e.target;

        setInputs((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSelectChange = (e) => {
        setInputs((prev) => ({
            ...prev,
            [e["name"]]: {value: 'tutu', label: 'Tutu', name: 'name'}
        }))
    }

    const options = [
        {value: 'toto', label: 'Toto', name: 'name'},
        {value: 'tata', label: 'Tata', name: 'name'},
        {value: 'tutu', label: 'Tutu', name: 'name'},
    ]

    const handleSubmit = (event) => {
        event.preventDefault();
        setStep(2);
    }

    const backButton = (event) => {
        event.preventDefault();
        setStep(0);
    }

    return (
        <form id="interim-second" onSubmit={handleSubmit}>
            <h3>Informations générales</h3>
            <p>Ajoutez les informations de votre agence d'interim.</p>
            <Select options={options} onChange={handleSelectChange} name="name" placeholder="Nom de l'agence" id="name"
                    value={inputs["name"] !== null ? inputs["name"] : undefined}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            border: 'none',
                            width: "100%"
                        })
                    }}
                    theme={(theme) => ({
                        ...theme,
                        border: 'none',
                        colors: {
                            ...theme.colors,
                            primary: 'none',
                        },
                    })}
            />
            <input type="text" onChange={handleChange} name="siret" placeholder="SIRET"
            value={inputs["siret"] !== null ? inputs["siret"] : undefined}
            />
            <Select options={options} onChange={handleSelectChange} name="adresse" placeholder="Adresse postale de l'agence" id="adresse"
                    value={inputs["name"] !== null ? options[inputs["name"]] : undefined}
                    styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        border: 'none',
                        width: "100%"
                    })
                }}
                    theme={(theme) => ({
                        ...theme,
                        border: 'none',
                        colors: {
                            ...theme.colors,
                            primary: 'none',
                        },
                    })}
            />
            <input type="text" onChange={handleChange} name="email" placeholder="Email professionnel"
            value={inputs["email"] !== null ? inputs["email"] : undefined}
            />
            <input type="text" onChange={handleChange} name="tel" placeholder="Téléphone professionnel"
                   value={inputs["tel"] !== null ? inputs["tel"] : undefined}
            />
            <div>
                <button className="btn empty" onClick={backButton}>← Retour</button>
                <button type="submit" className="btn fill white">Suivant →</button>
            </div>
        </form>
    )
}

export default CandidateFirstForm;